<template>
  <div id="create-order">

    <v-form v-model="valid" ref="form">
      <v-container class="padding-40">
        <v-layout row wrap>
          <v-flex xs12>
            <h1 class="headline">Bestel je pasfoto</h1>
            <br>

            <div>MAPS</div>
            <v-select
                solo
                v-model="store_id"
                :items="stores"
                label="Winkel zoeken"
            ></v-select>

          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12>
                <h2 class="order">Bepaal aantal pasfoto vellen</h2>
                <p>Er zitten 4 pasfoto's op 1 vel. De kosten van 1 vel zijn &euro; 3,95.</p>
              </v-flex>


              <v-flex xs4>
                <v-text-field
                    type="number"
                    label="Aantal"
                    v-model="amount"
                    name="amount"
                    solo
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <p class="text-xs-center ma-0 pt-3 pb-3"><strong>x &euro; 3,95</strong></p>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <strong>Totaalbedrag</strong><br>
                <strong>&euro; 3,95</strong>
              </v-flex>

            </v-layout>
          </v-flex>
          <v-flex xs12>
            <h2 class="order">Jouw gegevens</h2>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                    label="Voornaam"
                    v-model="first_name"
                    :error-messages="errors.collect('first_name')"
                    name="first_name"
                    v-validate="'required'"
                    solo
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    label="Achternaam"
                    v-model="last_name"
                    :error-messages="errors.collect('last_name')"
                    v-validate="'required'"
                    name="last_name"
                    solo
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    type="email"
                    v-validate="'required|email'"
                    label="E-mailadres"
                    name="email"
                    :error-messages="errors.collect('email')"
                    v-model="email"
                    solo
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                    label="Ik ga akkoord met de algemene voorwaarden"
                    v-validate="'required:true'"
                    name="terms_and_conditions"
                    :error-messages="errors.collect('terms_and_conditions')"
                    v-model="terms_and_conditions"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-footer ref="footer" color="white" class="background-white" height="auto">
        <v-container class="pa-0" fluid style="padding-top: 0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn block color="#2E4278" class="v-btn__use-photo" dark @click="submitOrder">Bestel mijn pasfoto's</v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn round dark color="#EE1D25" style="margin:15px 0 25px 40px;" @click="$router.push('/photo')" class="v-btn__go-back"><i class="rotate-90 icon icon-kruidvat-arrow icon-white"></i> Terug</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-footer>

    </v-form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  import BackendService from "@/services/BackendService";

  Vue.use(VeeValidate);

  export default {
    $_veeValidate: {
      validator: 'new'
    },
    name: 'order',
    data() {
      return {
        valid: false,
        amount: 1,
        store_id: '',
        terms_and_conditions: false,
        first_name: '',
        last_name: '',
        email: '',
        stores: [],
        imageUrl: '',
      }
    },
    dictionary: {
      nl: {
        attributes: {
          first_name: 'Voornaam',
          last_name: 'Achternaam',
          email: 'E-mailadres',
        },
        messages: {
          required: (fieldName) => `${fieldName} is een verplicht veld`
        },
        custom: {
          terms_and_conditions: {
            required: "Je moet akkoord gaan om een bestelling te kunnen plaatsen"
          }
        }
      }
    },
    mounted() {
      this.checkOrderExists();
      this.$validator.localize(this.$options.dictionary);
      this.$validator.localize('nl');
      this.showPreview();
    },
    watch: {
      '$route': 'checkOrderExists'
    },
    methods: {
      checkOrderExists() {
        if (localStorage.orderPlaced && localStorage.orderPlaced == localStorage.photoKey) {
          this.$router.push('/order-status');
        }
      },
      showPreview() {
        if (localStorage.photo) {
          this.imageUrl = localStorage.photo;
        }
      },
      submitOrder() {
        this.$validator.validateAll()
          .then((result) => {
            if (result) {
              let token = localStorage.accessToken;
              let key = localStorage.photoKey;
              let data = {
                key: key,
                amount: this.amount,
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email
              };
              BackendService.createOrder(data,token)
                .then((response) => {
                  localStorage.orderPlaced = key;
                  this.$router.push('/order-status')
                })
                .catch((error)=>{console.log(error);})
            }
          })
      },
    },
  };
</script>

<style scoped>

  body {
    background-color: #F0F0F0;
  }

  #camera {
    /*text-align: center;*/
    /*color: #2c3e50;*/
    /*margin-top: 60px;*/
  }

  #wrapper-background {
    background: #000;
  }

  .errors {
    background: rgba(0, 0, 0, 0.4);
    color: white;
    padding: 8px;
    position: absolute;
  }

  .errors li {
    display: list-item;
  }

  #errors-face {
    width: 200px;
    height: 300px;
    margin-left: -100px;
    margin-top: -150px;
    left: 50%;
    top: 50%;
  }

  #wrapper {
    position: relative;
    overflow: hidden;
    margin: 0 auto;
  }

  #scanning-overlay {
    position: absolute;
    font-size: 18px;
    color: yellow;
    text-transform: uppercase;
    font-weight: bold;
    top: 20px;
    left: 20px;
  }

  li {
    display: inline;
    padding: 5px;
  }

  video {
    background: #000;
    object-fit: cover;
  }
</style>
